<div fxLayout="column" ngClass.desktop="pl-56 pr-56 pt-48 pb-48 shadow-content" ngClass.mobile="pt-24 pl-16 pr-16 w-100"
     fxFlexAlign="center" fxLayoutAlign="center center">
    <ui-kit-svg class="i-80" [name]="type === QrInfoType.WARNING && 'ic_warning' || 'ic_succeeded'"></ui-kit-svg>
    <div class="h3-semi-bold text-center c-primary-gray-900 mt-40 pre-line">
        {{ (type === QrInfoType.WARNING && 'i18n_auth_warningLivenessQrTitle' || 'i18n_auth_succeededLivenessQrTitle') | translate }}
    </div>
    <div class="t2 mt-16 pre-line text-center">
        {{ (type === QrInfoType.WARNING && 'i18n_auth_warningLivenessQrSubtitle' || 'i18n_auth_succeededLivenessQrSubtitle') | translate }}
    </div>
    @if (type === QrInfoType.WARNING) {
        <ui-kit-button class="w-100 mt-32" [label]="'i18n_auth_buttonAcceptLivenessQr' | translate"
                       spinnerId="scanQr"
                       (clickListener)="navigateToLivenessQr()">
        </ui-kit-button>
        <ui-kit-button class="w-100 mt-16" type="secondary" [label]="'i18n_auth_buttonCancel' | translate"
                       [disabled]="Spinner.isShown('scanQr')"
                       (clickListener)="cancelAndNavigateToLanding()">
        </ui-kit-button>
    }
</div>
